"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

export default function NavbarItem({ href, label }) {
  const pathname = usePathname();
  const isActive =
    href === "/"
      ? pathname === "/"
      : pathname === href || pathname.startsWith(href + "/");

  return (
    <Link
      href={href}
      className={`block py-2 px-3 rounded-sm md:p-0 ${
        isActive
          ? "text-primary underline underline-offset-4"
          : "text-gray-900 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary dark:text-white md:dark:hover:text-primary dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
      }`}
    >
      {label}
    </Link>
  );
}
